import {
  ActionReducerMap,
  ActionReducer,
  MetaReducer,
  createFeatureSelector
} from '@ngrx/store';

import * as fromRouter from '@ngrx/router-store';
import { environment } from '@env/environment';
import { RouterStateUrl } from '@app/shared/utils';

export interface ReportAppState {
  router: fromRouter.RouterReducerState<RouterStateUrl>;
};

export const selectorRouter = createFeatureSelector<any>('router');

export const reducers: ActionReducerMap<ReportAppState> = {
  router: fromRouter.routerReducer,
};

export function logger(reducer: ActionReducer<ReportAppState>): ActionReducer<ReportAppState> {
  return function(state: ReportAppState, action: any): ReportAppState {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<ReportAppState>[] = !environment.production
? [logger]
: [];
